import request from '@/utils/request'

const apiPath = '/cust/otherFollowCustRecord'

const otherFollowCustRecordApi = {
  /**
   * 新增【其他跟进记录】
   */
  save(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【其他跟进记录】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【其他跟进记录】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【其他跟进记录】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【其他跟进记录】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【其他跟进记录】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
}

export default otherFollowCustRecordApi
